import { CSSProperties, useState } from "react";
import { AdminDiscussDetailModel } from "../../../../../../hooks/community/models/AdminDiscussDetailModel";
import { AdminDiscussionListModel } from "../../../../../../hooks/community/models/AdminDiscussionListModel";
import { CommunityFormEnum } from "../../../../../community/enums/CommunityFormEnum";
import { CommunityAdminDetails } from "../../../../../communityAdmin/components/CommunityAdminDetails";
import { ProfileMemberCommunityStats } from "../ProfileMemberCommunityStats";
import { ProfileMemberCommunityTab } from "../ProfileMemberCommunityTab";
import { ProfileMemberForum } from "../ProfileMemberForum";
import { ProfileMemberMastermind } from "../ProfileMemberMastermind";
import { ProfileMemberPending } from "../ProfileMemberPending";

const titleStyles: CSSProperties = {
    fontFamily: 'Satoshi',
    fontSize: '12px',
    fontWeight: '900',
    lineHeight: '185%',
    letterSpacing: '1.8px',
    textTransform: 'uppercase'
}

type Props = {
    userId: number;
    onReview: (e: AdminDiscussDetailModel) => void;
}

export const ProfileMemeberCommunityList = ({ userId, onReview }: Props) => {
    const [ section, setSection ] = useState<CommunityFormEnum>(CommunityFormEnum.OPEN_DISCUSSION);
    const [ selected, setSelected ] = useState<AdminDiscussionListModel | undefined>(undefined);
    const [reloadKey, setReloadKey] = useState(0);
    const reloadAll = () => {
        setReloadKey(Math.random());
    };
    return (
        <>
        { selected &&
            <CommunityAdminDetails 
                onReloadList={reloadAll}
                detail={selected} 
                onClose={() => setSelected(undefined)}
                onReview={onReview}
            />
        }
        <div className="d-flex flex-column w-100" style={{ gap: '40px' }}>
            <ProfileMemberCommunityTab section={section} setSection={setSection} />
        
            <ProfileMemberCommunityStats userId={userId} section={section} reloadKey={reloadKey}/>
            <ProfileMemberPending 
                userId={userId} 
                titleStyles={titleStyles} 
                section={section}
                onSelect={setSelected}
                reloadKey={reloadKey}
            />
            {section === CommunityFormEnum.MASTERMIND_CIRCLE && 
                <ProfileMemberMastermind 
                    userId={userId} 
                    titleStyles={titleStyles} 
                    onSelect={setSelected}
                    reloadKey={reloadKey}
                />
            }
            {section === CommunityFormEnum.OPEN_DISCUSSION &&
                <ProfileMemberForum 
                    userId={userId} 
                    titleStyles={titleStyles} 
                    onSelect={setSelected}
                    reloadKey={reloadKey}
                />
            }
        </div>
        </>
    )
}